import artist from './artist.png'
import codeveloper from './codeveloper.png'
import creator from './creator.png'

//This functional component imports the team members' images and contains their info
function Team () {

    return (
        <div className='team'>
            <div className='team-column'>
                <img className='team-images' id='creator-image' src={creator} alt='creator' />
                <div id='creator-text'>
                    <h4>Reading Pea</h4>
                    <p>Creator</p>
                </div>
            </div>
            <div className='team-column'>
                <img className='team-images' id='codeveloper-image' src={codeveloper} alt='codeveloper' />
                <div id='codeveloper-text'>
                    <h4>Angry Arabian Cookie</h4>
                    <p>Codeveloper</p>
                </div>
            </div>
            <div className='team-column'>
                <img className='team-images' id='artist-image' src={artist} alt='artist'/>
                <div id='artist-text'>
                    <h4>Smiling Crayfish</h4>
                    <p>Artist</p>
                </div>
            </div>
        </div>
    )
}

export default Team